// Пульт правил: /api/v2/rules (erp-backend, модуль src/rules).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchRules() {
  const { data } = await api.get('rules')
  return data
}

export async function changeRule(key, value, comment) {
  const { data } = await api.put(`rules/${encodeURIComponent(key)}`, { value, comment })
  return data
}

export async function resetRule(key, comment) {
  const { data } = await api.post(`rules/${encodeURIComponent(key)}/reset`, { comment })
  return data
}

export async function fetchRuleHistory(key) {
  const { data } = await api.get(`rules/${encodeURIComponent(key)}/history`)
  return data
}
